export const PROCTORING_SUBCONTROLS_LIBRARY = {
  detectFace: {
    label: "Monitoring: Detect face throughout session",
    description:
      "Verify that a face is consistently detected throughout the assessment session.",
    sortOrder: 1,
  },
  compareSource: {
    label: "Monitoring: Match candidate's face to reference image",
    description:
      "Verify that the face detected in the assessment session matches the reference image captured during the monitoring setup.",
    sortOrder: 2,
  },
  detectMultipleFaces: {
    label: "Monitoring: Detect multiple people",
    description:
      "Flags when more than one person is detected in the assessment session.",
    sortOrder: 3,
  },
  detectDevice: {
    label: "Monitoring: Detect mobile phones",
    description: "Flag when a mobile phone is visible.",
    sortOrder: 4,
  },
  screenCapture: {
    label: "Capture screen",
    description:
      "Capture images of the candidate's screen from their assessment session. Note that screen capture only works on a desktop.",
    sortOrder: 5,
  },
  audioCapture: {
    label: "Capture audio",
    description: "Capture audio clips from the candidate's assessment session.",
    sortOrder: 6,
  },
};
